import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightReceptivity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.0005 2.6667L20.7188 5.85546C21.3281 8.56023 23.4403 10.6724 26.1451 11.2817L29.3339 12L26.1451 12.7183C23.4403 13.3276 21.3281 15.4398 20.7188 18.1446L20.0005 21.3334L19.2823 18.1446C18.6729 15.4398 16.5608 13.3276 13.856 12.7183L10.6672 12L13.856 11.2817C16.5607 10.6724 18.6729 8.56023 19.2823 5.85547L20.0005 2.6667Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.33385 16L9.84693 18.2777C10.2821 20.2096 11.7909 21.7184 13.7228 22.1536L16.0005 22.6667L13.7228 23.1797C11.7909 23.6149 10.2821 25.1236 9.84693 27.0556L9.33385 29.3333L8.82077 27.0556C8.38557 25.1236 6.87685 23.6149 4.94488 23.1797L2.66719 22.6667L4.94488 22.1536C6.87685 21.7184 8.38557 20.2097 8.82077 18.2777L9.33385 16Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgInsightReceptivity;
